import React, { useState, useEffect, useRef } from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import RenderItem from "../../common/renderItem";
import { formatCurrency } from "../../common/format-currency";
import { connect } from "react-redux";
import {
  UpdateCartCount,
  UpdateCartAmount,
  UpdateCartID,
} from "../../redux/actions/postActions";
import MyStorage from "../../common/MyStorage";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import _ from "lodash";
import {
  KMTracking,
  campaignRecord,
} from "../../components/Tracking/KMTracking";
import JustMerchants from "../../common/constants";
import ContentLoader, { List } from "react-content-loader";
import cleanURL from "../../common/cleanURL";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import TagManager from 'react-gtm-module'
 
const tagManagerArgs = {
    dataLayer: {
        userId: '001',
        userProject: 'project',
        page: 'Add-To-Bag'
    },
    dataLayerName: 'PageDataLayer'
}

var kmAddProductProps = {};
var varPrice = 0;
var Price: any = 0;
const MyListLoader = () => <List />;
const MyLoader = () => (
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="350" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="700" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="3" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="350" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="700" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="330" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="371" rx="4" ry="4" width="131" height="33" />
    <rect x="350" y="330" rx="4" ry="4" width="300" height="29" />
    <rect x="350" y="371" rx="4" ry="4" width="116" height="30" />
    <rect x="700" y="330" rx="4" ry="4" width="173" height="29" />
    <rect x="700" y="371" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);
var catSet = false;
function ProductDesc(props) {
  const [product, setProduct] = useState<any>({});
  const [productImages, setProductImages] = useState<any>({});
  const [selectedProductImage, setSelectedImages] = useState("");
  const [productQty, setProductQty] = useState<number>(1);
  const [productQtyAdded, setProductQtyAdded] = useState<number>(0);
  const [soldByName, setSoldByName] = useState("");
  const [soldByID, setSoldByID] = useState("");
  const [mallName, setMallName] = useState("");
  const [returnPolicy, setReturnPolicy] = useState("");
  const [sizingChartImage, setSizingChartImage] = useState("");
  const [categories, setCategories] = useState("");
  const [productList, setProductList] = useState("");
  const [dataShow, setDataShow] = useState<any>([]);
  const [indexSelect, setIndexSelect] = useState(0);
  const [merchantID, setMerchantID] = useState("");
  const [variantsID, setVariantsID] = useState("");
  const [variantsSelectedID, setVariantsSelectedID] = useState<any>([]);
  const [variantsSelect, setVariantsSelect] = useState<any>([]);
  const [variantsArray, setVariantsArray] = useState<any>([]);
  const [variantsObject, setVariantsObject] = useState<any>([]);
  const [buttonTitle, setButtonTitle] = useState("Add to Bag");
  const [is_loading, setIsLoading] = useState(false);
  const [isProductAdded, setIsProductAdded] = useState(false);
  const [variantsError, setVariantsError] = useState([]);
  const [subCat, setSubCat] = useState<any>({});
  const [dynamic_text, setDynamictext] = useState("");
  const [delivery_time_estimation, setDeliveryTimeEstimation] = useState("");
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [productsLoading, setProductsLoading] = useState(true);
  const [returnLoading, setReturnLoading] = useState(true);
  const [SelfCollectionSubText, setSelfCollectionSubText] =
    useState<String>("");

  const [categoryMain, setMainCat] = useState("");
  const [cat_id, setCatID] = useState("");
  const [fulfilmentDelivery, setFulfilmentDelivery] = useState("");
  const [fulfilmentSelfCollection, setFulfilmentSelfCollection] = useState("");
  const [deliverySubText, setDeliverySubText] = useState("");

  const ForceUpdate = useState<any>()[1].bind(null, {});
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const slider = useRef<any>();
  useEffect(() => {
    props.location.search &&
      campaignRecord(props.location.search, props.location.pathname);
    getSettings();
    getShoutouts();
    getMemberInfo()
  }, []);
  useEffect(() => {}, [categoryMain, subCat]);
  useEffect(() => {
    Price = 0;
    varPrice = 0;
    window.scrollTo(0, 0);
    setProductQty(1);
    const productID = props?.match?.params?.productID;
    if (productID !== "") {
      fetchCurrentProduct(productID);
    }
  }, [
    props?.match?.params?.productID,
    props?.match?.params?.productName,
    variantsID,
  ]);

  const getMemberInfo= async()=>{
    let accessToken : any = localStorage.getItem("authenticationFrasers");
    var myHeaders:any = new Headers();
    myHeaders.append("Authorization",  accessToken);
    myHeaders.append("Content-Type" , "application/json");
    const params:any = {
      version:31,
      website:true
  };
    var requestOptions:any = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(params)
    };
  await new WebApiCalls().getMemberInfo(requestOptions)
   .then((response)=>{
    if(response.error.includes("Invalid")){
      localStorage.clear();
      props?.history?.push("/login", { from: "Product Description" });
    }
  })
    .catch((error)=>{console.log("error",error)})
  }

  const getSettings = async () => {
    await new WebApiCalls().getSettings().then((_response) => {
      if (_response.data) {
        if (_response.data.Items.length > 0) {
          _response.data.Items.map((item) => {
            if (item.item_name == "estore_delivery_time") {
              setDeliveryTimeEstimation(item.item_detail);
            }
          });
        }
      }
    });
  };
  const fetchCurrentProduct = async (ID) => {
    setDataLoading(true);
    await new WebApiCalls().getSingleItem(ID).then((response) => {
      if (response.ID) {
        let parentID = response?.Categories[0]?.ID;
        const BrandName = response?.CustomFields
          ? response?.CustomFields.length > 0
            ? response?.CustomFields.filter((item) =>
                item.Name.includes("Brand")
              ).length > 0
              ? response?.CustomFields.filter((item) =>
                  item.Name.includes("Brand")
                )[0].Values[0]
              : ""
            : ""
          : "";
        response.brandName = BrandName;
        const data = {
          "Current Page": "ProductDescription",
          "Product Name": response.Name,
          "Source Page": props?.location?.state?.from
            ? props?.location?.state?.from
            : "",
        };
        tracker("pageviewed", data);
        JustMerchants(response?.MerchantDetail?.ID).then((result) => {
          let data = {
            currency: response?.CurrencyCode,
            value: response?.Price,
            items: [
              {
                item_id: response?.ID,
                item_name: response?.Name,
              }
            ],
            "Mall Name": result["MallName"],
            "Store Name": result["StoreName"],
            "Product Name": response.Name,
            "Product Price": response.Price,
            "Product ID": response.ID,
            "Product Availability": response.IsAvailable
              ? "Available"
              : "Not Available",
            "Brand Name": BrandName,
          };
          kmAddProductProps = { ...data };
          tracker("viewedproduct", data);
          tracker("view_item", data);
          // Track Product Viewed Internal for Tranding Products
          (new WebApiCalls()).trackProductViews(response.ID);
        });
        setProduct(response);
        setDataLoading(false);
        if (response?.Media?.length > 0) {
          setProductImages(response?.Media);
          setSelectedImages(response?.Media[0]?.MediaUrl);
        }
        fetchVariants(response);
        if (response) {
          getMerchants(response?.MerchantDetail?.ID);
          setMerchantID(response?.MerchantDetail?.ID);
        }
        response?.Categories?.map((item, index) => {
          if (
            (item?.Name?.toLowerCase()?.includes("featured") ||
              item?.Name?.toLowerCase()?.includes("trending") ||
              item?.Name?.toLowerCase()?.includes("join the") ||
              item?.Name?.toLowerCase()?.includes("care")) &&
            !catSet
          ) {
            // console.log("Coming in wrong category", item)
          } else if (!catSet) {
            // console.log("Coming in Right category", item)
            setMainCat(item?.Name);
            setCatID(item?.ID);
            if (
              (item?.ParentCategoryID == "" ||
                item?.ParentCategoryID == null ||
                item?.ParentCategoryID == undefined) &&
              response?.Categories[index + 1]
            ) {
              // console.log("Coming in Sub Categ", item)
              setSubCat(response?.Categories[index + 1]);
            }
            catSet = true;
          }
          if (item?.ParentCategoryID == parentID) {
            // console.log("coming in subcat")
            setSubCat(item);
          }
        });
        fetchOtherProducts(response);
      } else {
        props.history.push("/")
      }
    });
  };
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };

  const groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
    }, {});
  };
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  const fetchVariants = (product: any) => {
    let item = product;
    let variants = {};
    let variantsArray: any = [];
    let groupbyArr: any = [];
    let selectedArr: any = [];
    let selectdID: any = [];
    console.log("here come Data--------------->", item);
    item?.ChildItems?.forEach((i) => {
      console.log("here 'childItem' object on each iteration", i);
      i?.Variants?.forEach((v: any) => {
        console.log("here come the v on each iteration===========>", v);
        if (!variants[v?.GroupName]) {
          //assign the value of v.GroupName(which is Size) as a key of variants like variants.Size={}
          variants[v?.GroupName] = {};
          console.log("here come the variants=======>", variants);
        }
        //take the value of v.name(and also assign the whole v to it) on each iteration and insert into 1st key of variants objects
        variants[v.GroupName][v.Name] = v;
        console.log("Now the veriant is comming again======>", variants);
        if (variantsArray.length > 0) {
          if (
            variantsArray.filter((item: any) => item?.ID.includes(v.ID))
              .length === 0
          ) {
            variantsArray.push(v);
            groupbyArr.push(v.GroupName);
          }
        } else {
          variantsArray.push(v);
          groupbyArr.push(v.GroupName);
        }
      });
    });
    const groupedPeople: any = groupBy(variantsArray, "GroupName");
    const uniqueArr: any = groupbyArr?.filter(onlyUnique);

    uniqueArr.map((item, index) => {
      if (variantsSelect.length < 1 || variantsSelect.includes("no")) {
        selectedArr.push("no");
        selectdID.push("no");
        if (index === uniqueArr.length - 1) {
          setVariantsSelect(selectedArr);
          setVariantsSelectedID(selectdID);
        }
      }
    });

    if (uniqueArr.length > 0) {
      setVariantsArray(uniqueArr);
      setVariantsObject(groupedPeople);
    } else {
      setVariantsArray([]);
      setVariantsObject([]);
      setVariantsSelect([]);
      setVariantsSelectedID([]);
    }
    setTimeout(() => {
      ForceUpdate();
    }, 2000);
  };
  const fetchOtherProducts = async (prod) => {
    setProductsLoading(true);

    let accessToken = await localStorage.getItem("access_token");
    let body = {
      pageNumber: 1,
      pageSize: 10,
      Categories: "",
      sellerID: prod ? prod.MerchantDetail?.ID : "",
      CustomFieldQueries: "",
    };
    await new WebApiCalls()
      .getItemsByFilters(body, accessToken)
      .then((response) => {
        response?.Records?.map((item: any) => {
          const BrandName = item?.CustomFields
            ? item?.CustomFields.length > 0
              ? item?.CustomFields.filter((item) => item.Name.includes("Brand"))
                  .length > 0
                ? item?.CustomFields.filter((item) =>
                    item.Name.includes("Brand")
                  )[0].Values[0]
                : ""
              : ""
            : "";
          item.brandName = BrandName;
        });
        let tempArr = response?.Records;
        tempArr?.map((item, index) => {
          if (
            item?.AddOns?.length < 1 &&
            item?.StockLimited &&
            item?.StockQuantity < 1
          ) {
            tempArr.splice(index, 1);
          }
        });

        tempArr = tempArr.filter((item) => item.ID != prod?.ID);
        setProductList(tempArr);
        setProductsLoading(false);
      });
  };
  // const JustMerchants = async (merchantID) => {
  // 	let returnData = {}
  // 	await new WebApiCalls()
  // 		.getUserDetail(merchantID)
  // 		.then((response) => {
  // 			if (response) {
  // 				returnData["StoreName"] = response.DisplayName
  // 				response.CustomFields.map((item, index) => {
  // 					if (item.Name == "Mall") {
  // 						returnData = {
  // 							...returnData,
  // 							...{ "MallName": item.Values[0] },
  // 						};
  // 					}
  // 				})
  // 			}
  // 		})
  // 	return returnData
  // }
  const getMerchants = async (merchantID: number) => {
    await new WebApiCalls().getUserDetail(merchantID).then((response) => {
      if (response) {
        let bannerUrl = response.CustomFields
          ? response.CustomFields.filter((item) =>
              item.Name.includes("BannerURL")
            ).length > 0
            ? response.CustomFields.filter((item) =>
                item.Name.includes("BannerURL")
              )[0].Values[0]
            : ""
          : "";
        //   let staticbanner = require('../../images/storeDefault.jpg')
        console.log("Merchant == ", response);
        setSoldByName(response?.DisplayName);
        setSoldByID(response?.ID);
        let returnPolicy = "";

        if (response.CustomFields) {
          if (response.CustomFields.length > 0) {
            response.CustomFields.map((item, index) => {
              console.log("Item here inside get merchant---->", item);
              if (item.Name == "Return Policy") {
                returnPolicy = item.Values[0];
                setReturnPolicy(returnPolicy);
              } else if (index === response.CustomFields.length - 1) {
                if (returnPolicy == "") {
                  setReturnPolicy("No Policy");
                }
              }
              if (item.Name == "SizingChartUrl") {
                setSizingChartImage(item?.Values[0]);
              }
              if (item.Name == "Mall") {
                kmAddProductProps = {
                  ...kmAddProductProps,
                  ...{ "Mall Name": item.Values[0] },
                };
                setMallName(item?.Values[0]);
              }
              if (item.Name == "FulfilmentDelivery") {
                console.log("here come the item------->", item);
                if (item.Values[0] == "na") {
                  setFulfilmentDelivery(`Delivery`);
                  setDeliverySubText(`Delivery not available`)
                } else if (item.Values[0] == "merchant") {
                  setFulfilmentDelivery(`- Delivery by Merchant`);
                  setDeliverySubText(
                    `Items from this store will be delivered by Merchant. Frasers eStore will not be able to provide tracking updates.`
                  );
                } else if (item.Values[0] == "frasers") {
                  setFulfilmentDelivery(`Delivery by Frasers eStore`);
                  setDeliverySubText(
                    `Delivery & tracking updates provided by Frasers eStore.`
                  );
                } else {
                  //added for default case
                  setFulfilmentDelivery("frasers");
                  setDeliverySubText(
                    `Delivery & tracking updates provided by Frasers eStore.`
                  );
                }
              }

              // console.log("Item is:	", item)
              if (item.Name == "FulfilmentSelfCollection") {
                if (item.Values[0] == "na") {
                  setFulfilmentSelfCollection("Self Collection");
                  setSelfCollectionSubText("Self Collection is not available");
                } else {
                  setFulfilmentSelfCollection("Self Collection");
                  const mallName =
                    response?.CustomFields?.filter((item) =>
                      item?.Name.includes("Mall")
                    ).length > 0
                      ? response?.CustomFields.filter((i) =>
                          i.Name.includes("Mall")
                        )[0].Values[0]
                      : "";
                  setSelfCollectionSubText(
                    `Self collect at ${response?.DisplayName}${
                      mallName ? ", " + mallName + "." : "."
                    }`
                  );
                }
              }
              setReturnLoading(false);
            });
          } else {
            setReturnPolicy("No Policy");
            setReturnLoading(false);
          }
        } else {
          setReturnPolicy("No Policy");
          setReturnLoading(false);
        }
      }
    });
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: "31%",
          marginRight: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-next">
          <img src="images/next.png" />
        </div>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: "31%",
          marginLeft: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-prev">
          <img src="images/prev.png" />
        </div>
      </div>
    );
  }
  const getShoutouts = async () => {
    let checkoutText: any = [];
    await new WebApiCalls().getShoutouts().then((_response) => {
      if (_response.data) {
        if (_response.data.length > 0) {
          _response.data.map((item) => {
            if (item.type == "eStoreCheckoutText" && item.status == "Y") {
              checkoutText.push(item);
            }
          });
          let sort = checkoutText.sort((a, b) => {
            return (
              new Date(b.publish_date).getTime() -
              new Date(a.publish_date).getTime()
            );
          });
          setDynamictext(sort[0]?.description);
        }
      }
    });
  };
  const renderMiniSlider = (imgArray: any, slides: number) => {
    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slides,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      centerMode: false,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <Slider {...settings} ref={slider}>
        {imgArray.length > 0 &&
          imgArray?.map((item: any, index: number) => {
            if (
              item.Name == "Delivery" ||
              item.Name == "delivery" ||
              item.Name == "Frasers eStore Delivery"
            ) {
              return;
            }
            return (
              <RenderItem
                key={index}
                item={item}
                onClickItem={onClickItem}
                is_slider={true}
                from={"Product Description"}
              />
            );
          })}
      </Slider>
    );
  };
  const checkVariantsID = () => {
    let varID = "";
    let variantsID: string[] = [];
    let isEqual: string[] = [];
    product.ChildItems.map((item, indes) => {
      variantsID = [];
      isEqual = [];
      item.Variants.map((item2: any, index2: number) => {
        variantsID.push(item2.ID);
        if (index2 === item.Variants.length - 1) {
          variantsSelectedID.map((item3, index3) => {
            isEqual.push("n");
            if (item3 === variantsID[index3]) {
              isEqual[index3] = "y";
            }
            if (index3 === variantsSelectedID.length - 1) {
              const IDnotFindt = isEqual.includes("n");
              if (!IDnotFindt) {
                setVariantsID(item.ID);
                varID = item.ID;
              }
            }
          });
        }
      });
    });
    return varID;
  };
  console.log("here is the selected variant ID", variantsSelectedID);
  const fetchingToken = async (data) => {
    let obj = {
      contactID: data.contact_id,
      email: data.email,
      authentication: data.authentication,
      phoneNumber: data.phoneNumber,
      name: data.name,
    };
    localStorage.setItem("contactIDFrasers", obj.contactID);
    localStorage.setItem("emailFrasers", obj.email);
    localStorage.setItem("authenticationFrasers", obj.authentication);
    localStorage.setItem("PhoneNumber", obj.phoneNumber);
    localStorage.setItem("name", obj.name);
    const storage = new MyStorage();
    let userID = storage.getUserId();
    let access_token = storage.getaccess_token();
    let ssoCode = storage.getSsoCode();
    if (!userID && !access_token && !ssoCode) {
      await new WebApiCalls().getToken(obj).then(async (response) => {
        if (response.AccessToken) {
          localStorage.setItem("UserId", response.AccessToken.UserId);
          localStorage.setItem(
            "access_token",
            response.AccessToken.access_token
          );
          localStorage.setItem("SsoCode", response.SsoCode);
          seeCart();
        }
      });
    }
  };
  const seeCart = async () => {
    // this.setState({ cartSpinner: true });
    const localStorage = new MyStorage();
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getCartDetail(userID, accessToken)
      .then(async (Response) => {
        console.log("Response =", Response);
        if (Response.errorType) {
          //get access_token again if expired
          // let _name = await localStorage.getItem("name");
          // let _contactID = await localStorage.getItem("contactIDFrasers");
          // let _email = await localStorage.getItem("emailFrasers");
          // let _phoneNumber = await localStorage.getItem("PhoneNumber");
          // let _token = await localStorage.getItem("authenticationFrasers");
          // let obj = {
          // 	contact_id: _contactID,
          // 	email: _email,
          // 	phoneNumber: _phoneNumber,
          // 	authenticationFrasers: _token,
          // 	name: _name,
          // 	authentication: _token,
          // };
          // fetchingToken(obj);
          props?.history?.push("/login", { from: "Product Description" });
        } else if (
          !Response ||
          Response === null ||
          Response?.body?.length == 0
        ) {
          setIsLoading(false);
        } else if (Response.statusCode === 200) {
          setIsProductAdded(true);
          await new WebApiCalls()
            .seeCart(userID, accessToken)
            .then(async (response) => {
              if (response.Records.length > 0) {
                let a: any = 0;
                let b: any = 0;
                a = response.Records.map((item) => {
                  return parseInt(a + item.Quantity);
                });
                a.map((aitem) => {
                  b = b + aitem;
                });
                let total = 0;
                let itemID: any = [];
                await response.Records.map(async (item) => {
                  total = total + item.SubTotal;
                  itemID.push(item.ID);
                  let obj = {
                    ID: item.ItemDetail.ID,
                  };
                  localStorage.setCartAmount(total);
                  // localStorage.setCartCount(response.Records.length);
                  props.UpdateCartAmount(total);
                  // props.UpdateCartCount(response.Records.length);
                });
                setIsLoading(false);
              } else {
                setIsLoading(false);
              }
            });
        }
      });
  };
  const addItemToCart = async () => {
    TagManager.dataLayer(tagManagerArgs)

    setIsLoading(true);
    setProductQtyAdded(productQty);
    let size = false;
    let selectedSize = "";
    let color = false;
    let selectedColor = "";
    let ID = "";
    if (variantsSelect && variantsSelect.length > 0) {
      variantsSelect.map((item, index) => {
        if (variantsArray[index] === "Size") {
          size = true;
          selectedSize = item;
        }
        if (variantsArray[index] === "Color") {
          color = true;
          selectedColor = item;
        }
      });
      if (variantsArray?.length > 0) {
        let _temp: any = [];
        variantsSelect?.map((itemV, indexV) => {
          if (itemV == "no") {
            _temp = [..._temp, variantsArray[indexV]];
          }
        });
        if (_temp?.length > 0) {
          setVariantsError(_temp);
          setIsLoading(false);
          return;
        }
      }
    }
    if (variantsArray.length > 0) {
      const varID = checkVariantsID();
      ID = varID ? varID : variantsID;
    } else {
      ID = product.ID;
    }
    if (ID) {
      let itemObj = {
        ItemDetail: {
          ID: ID,
        },
        Quantity: productQty,
        CartItemType: product.SKU,
        // ShippingMethod: {
        //     ID: this.state.product.ShippingMethod
        // },
        PickupAddress: {
          ID: product.PickupAddress,
        },
      };
      // this.setState({ addTocartSpinner: true });
      kmAddProductProps = {
        ...kmAddProductProps,
        ...{
          currency: product?.CurrencyCode,
          value: product?.Price,
          item: [
            {
              item_id: product?.ID,
              item_name: product?.Name,
            }
          ],
          "Product sku": product.SKU ? product.SKU : "",
          "Product quantity": productQty,
          "Product size": size ? selectedSize : "",
          "Product color": color ? selectedColor : "",
        },
      };

      await tracker("addedtobag", kmAddProductProps);
      await tracker("add_to_cart", kmAddProductProps);

      const storage = new MyStorage();
      let userID = await storage.getUserId();
      let accessToken = await storage.getaccess_token();
      if (userID && accessToken && itemObj) {
        // console.log('Hello called', itemObj)
        await new WebApiCalls()
          .addItem(userID, itemObj, accessToken)
          .then(async (response) => {
            if(response?.Message?.includes("denied")){
              setIsLoading(false);
              setIsProductAdded(true);
              props?.history?.push("/login", { from: "Product Description" });
            }
            else if (response.Code === 400) {
              setIsLoading(false);
              setIsProductAdded(true);
              props?.history?.push("/login", { from: "Product Description" });
            } else if (response) {
              let old_count: any = await new MyStorage().getCartCount();
              let new_count = parseInt(old_count ? old_count : 0) + productQty;
              new MyStorage().setCartID(response.ID);
              props.UpdateCartID(response.ID);
              props.UpdateCartCount(new_count);
              new MyStorage().setCartCount(JSON.stringify(new_count));
              await seeCart();
              // this.setState({ addTocartSpinner: false, buttonTitle: "VIEW BAG" });
            }
          });
      } else {
        props?.history?.push("/login", { from: "Product Description" });
      }
    }
  };
  const changeIsProduct = () => {
    setIsProductAdded(false);
  };
  const onClickItem = (_item) => {
    window.scrollTo(0, 0);
    slider.current.slickGoTo(0);
    setSizingChartImage("");
    // if (_item.Name.includes('/')) {
    // 	props?.history?.push(`/product/${(_item.Name).replace(/\\|\//g, '_')}/${_item.ID}`, { cat1: `${props?.location?.state?.cat1}`, cat2: `${props?.location?.state?.cat2}`, path: `/product/${(_item.Name).replace(/\\|\//g, '_')}/${_item.ID}` })
    // }
    // else {
    // 	props?.history?.push(`/product/${_item.Name}/${_item.ID}`, { cat1: `${props?.location?.state?.cat1}`, cat2: `${props?.location?.state?.cat2}`, path: `/product/${_item.Name}/${_item.ID}` })
    // }
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Product Description",
    });
  };
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  let stock = product.StockQuantity;
  let limitedStock = product.StockLimited;
  let selectedVariantImage = "";
  if (product.ChildItems?.length > 0) {
    stock = 0;
    limitedStock = false;
  }
  product?.ChildItems?.map((item, index) => {
    console.log(
      "here is varient selected id length-->",
      variantsSelectedID.length
    );
    product.StockQuantity == 0 && item.StockQuantity > 0
      ? (varQty = item.StockQuantity)
      : (varQty = 0);
    if (variantsSelectedID.length == 1) {
      item.Variants.map((data, i) => {
        if (variantsSelectedID.includes(data.ID)) {
          stock = item.StockQuantity;
          limitedStock = item.StockLimited;
          varPrice = item.Price;
          if (item.Media && item?.Media[0]?.MediaUrl !== "") {
            selectedVariantImage = item?.Media[0]?.MediaUrl;
            console.log(
              "here is the seleceted variant image********>",
              selectedVariantImage
            );
          }
        }
      });
    } else if (variantsSelectedID.length == 2) {
      variantsSelectedID.map((data, i) => {
        if (
          variantsSelectedID[0] == item.Variants[0].ID &&
          variantsSelectedID[1] == item.Variants[1].ID
        ) {
          stock = item.StockQuantity;
          limitedStock = item.StockLimited;
          varPrice = item.Price;
          if (item.Media && item?.Media[0]?.MediaUrl !== "") {
            selectedVariantImage = item?.Media[0]?.MediaUrl;
            console.log(
              "here is the seleceted variant image********>",
              selectedVariantImage
            );
          }
        }
      });
    } else if (variantsSelectedID.length == 3) {
      console.log("here is varient selected id length-->", variantsSelectedID);
      variantsSelectedID.map((data, i) => {
        if (
          variantsSelectedID[0] == item.Variants[0].ID &&
          variantsSelectedID[1] == item.Variants[1].ID &&
          variantsSelectedID[2] == item.Variants[2].ID
        ) {
          stock = item.StockQuantity;
          limitedStock = item.StockLimited;
          varPrice = item.Price;
          if (item.Media && item?.Media[0]?.MediaUrl !== "") {
            selectedVariantImage = item?.Media[0]?.MediaUrl;
            console.log(
              "here is the seleceted variant image********>",
              selectedVariantImage
            );
          }
        }
      });
    }
  });

  //change price on variants change
  var varQty = 0;
  var stockQuantity = product.StockQuantity;

  product.ChildItems?.map((item, index) => {
    stockQuantity == 0 && item.StockQuantity > 0
      ? (varQty = item.StockQuantity)
      : (varQty = 0);
    if (varQty > 0) {
      stockQuantity = varQty;
    }
    // let allVariants: any = []
    // item.Variants.map((data, i) => {
    // 	allVariants.push(data.Name)
    // })
    // if (_.isEqual(allVariants, variantsSelect)) {
    // 	varPrice = item.Price;
    // }
  });
  const OriginalPrice = product.CustomFields
    ? product.CustomFields.length > 0
      ? product.CustomFields.filter((item) =>
          item.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)")
        ).length > 0
        ? product.CustomFields.filter((item) =>
            item.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)")
          )[0].Values[0]
        : ""
      : ""
    : "";
  product.OriginalPrice = OriginalPrice;
  let isSale =
    product?.AddOns && product.AddOns?.length > 0
      ? product?.OriginalPrice
        ? true
        : false
      : product?.StockLimited
      ? product?.StockQuantity > 0
        ? product?.OriginalPrice
          ? true
          : false
        : true
      : false;
  // let price = product?.Price?.toString().includes('$') ? product?.Price : formatCurrency(product?.Price ? product?.Price : 0)
  console.log("here come varPrice--->", varPrice);
  if (varPrice) {
    Price = varPrice.toString().includes("$")
      ? varPrice
      : formatCurrency(varPrice ? varPrice : 0);
  } else {
    Price = product?.Price?.toString().includes("$")
      ? product?.Price
      : formatCurrency(product?.Price ? product?.Price : 0);
  }
  let btnTitle = buttonTitle;

  //Item Sold Out check
  if (limitedStock && stock < 1) {
    btnTitle = "SOLD OUT";
  } else if (product?.IsVisibleToCustomer === false) {
    btnTitle = "NOT AVAILABLE"
  }

  // console.log("product quantity is here=========>",productQty)
  return (
    <div>
      <Helmet>
        <meta property="og:title" content={product?.Name} data-rh="true" />
        <meta
          property="og:description"
          content={product?.BuyerDescription}
          data-rh="true"
        />
        <meta
          property="og:image"
          content={
            product?.Media?.length > 0 ? product?.Media[0]?.MediaUrl : ""
          }
          data-rh="true"
        ></meta>
      </Helmet>
      {/* /contain
			<div className="viewport"></div>

			{/* /container */}
      <div className="container">
        {/* header */}
        <Header
          props={{
            ...props,
            isProductAdded: isProductAdded,
            productQty: productQtyAdded,
            changeIsProduct: changeIsProduct,
          }}
        />
        {/* /header */}

        {/* mainmenu */}
        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />
        {/* /mainmenu */}

        {/* /content */}
        <div className="content">
          {/* breadcrumb-back */}
          <div className="breadcrumb-back">
            {/* breadcrumb */}
            {/* {console.log("Breadcrumbs check ++++++++", product?.Categories, categoryMain)} */}
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              {(props?.location?.state !== undefined &&
                props?.location?.state?.cat1 !== undefined &&
                props?.location?.state?.cat1 !== "undefined" &&
                props?.location?.state?.cat1 !== "") ||
              categoryMain ? (
                <Link
                  to={`/category/${
                    categoryMain !== ""
                      ? cleanURL(categoryMain) + "/" + cat_id
                      : cleanURL(props?.location?.state?.cat1) + "/" + cat_id
                  }`}
                >
                  {categoryMain !== ""
                    ? _.capitalize(categoryMain)
                    : _.capitalize(props?.location?.state?.cat1)}
                </Link>
              ) : (
                (product?.Categories?.length > 0 || categoryMain) && (
                  <Link
                    to={`/category/${
                      categoryMain !== ""
                        ? cleanURL(categoryMain)`/${cat_id}`
                        : cleanURL(product?.Categories[0]?.Name)
                    }/${product?.Categories[0]?.ID}`}
                  >
                    {categoryMain !== ""
                      ? _.capitalize(categoryMain)
                      : product?.Categories[0]?.description == "hidden" ||
                        product?.Categories[0]?.Name?.includes("Featured")
                      ? product?.Categories[1]?.Name?.includes("Featured")
                        ? _.capitalize(product?.Categories[2]?.Name)
                        : _.capitalize(product?.Categories[1]?.Name)
                      : _.capitalize(product?.Categories[0]?.Name)}
                  </Link>
                )
              )}
              {props?.location?.state !== undefined &&
              props?.location?.state?.cat2 !== undefined &&
              props?.location?.state?.cat2 !== "undefined" &&
              props?.location?.state?.cat2 !== "" ? (
                <Link
                  to={`/category/${cleanURL(
                    subCat !== "" ? subCat?.Name : props?.location?.state?.cat2
                  )}/${cat_id}`}
                >
                  {subCat !== ""
                    ? _.capitalize(subCat?.Name)
                    : _.capitalize(props?.location?.state?.cat2)}
                </Link>
              ) : (
                props?.location?.state?.cat2 == undefined &&
                Object.keys(subCat).length > 0 && (
                  <Link
                    to={`/category/${cleanURL(subCat?.Name)}/${subCat?.ID}`}
                  >
                    {subCat?.Name}
                  </Link>
                )
              )}
              <a>{product?.Name}</a>
            </div>
            {/* /breadcrumb */}

            <a onClick={() => props?.history?.goBack()} className="backbtn">
              BACK
            </a>
          </div>
          {/* /breadcrumb-back */}

          {/* detail */}
          <div className="detail">
            {/* detail-selection */}
            <section className="selection">
              {/* thumb */}
              <div className="thumb">
                <div className="gallery">
                  <img
                    src={
                      selectedVariantImage
                        ? selectedVariantImage
                        : selectedProductImage !== ""
                        ? selectedProductImage
                        : product?.Media?.length > 0 &&
                          product?.Media[0]?.MediaUrl
                    }
                    alt=""
                  />
                </div>
                <div
                  className="gallery-nav"
                  style={{ justifyContent: "flex-start" }}
                >
                  {productImages?.length > 1 &&
                    productImages?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="item"
                          style={{ marginRight: 7 }}
                          onClick={() => {
                            setSelectedImages(item?.MediaUrl);
                          }}
                        >
                          <img src={item?.MediaUrl} alt="" />
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* /thumb */}
              {/* option-panel */}
              <div className="option-panel">
                <div className="brand">
                  {product?.brandName?.replace(/&amp;/g, "&")}
                </div>
                <div className="product-name">{product?.Name}</div>
                <Link
                  style={{ textDecoration: "underline" }}
                  to={`/brand/${cleanURL(soldByName)}/${soldByID}`}
                  onClick={() => {
                    props?.history?.push(
                      `/brand/${cleanURL(soldByName)}/${soldByID}`,
                      { from: "Product Description" }
                    );
                  }}
                  className="soldby"
                >
                  Sold by {soldByName ? soldByName : ""},{" "}
                  {mallName ? mallName : ""}
                </Link>

                {console.log(
                  "here is comming product original price",
                  product.OriginalPrice
                )}
                {console.log("here is comming product price---->", Price)}
                {!product.OriginalPrice ? (
                  <div className={`price ${isSale ? "sale" : ""}`}>{Price}</div>
                ) : (
                  <>
                    {product.OriginalPrice && (
                      <div
                        className="price"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <div className="up" style={{ color: "red" }}>
                          {Price}
                        </div>

                        <div
                          className="sale"
                          style={{
                            textDecoration: "line-through",
                            marginLeft: 5,
                          }}
                        >
                          {formatCurrency(product?.OriginalPrice)}
                        </div>
                      </div>
                    )}
                  </>
                )}
                {/* <div className={`price ${isSale ? "sale" : ""}`}>
									{
										product.AddOns && product.AddOns.length > 0 ? formatCurrency(product.Price) :
											product.StockLimited ? product.StockQuantity > 0 ? formatCurrency(product.Price) : "Sold out" : product.Price ? formatCurrency(product.Price) : ''}
									{product.StockLimited && product.StockQuantity > 0 && OriginalPrice && (
										<div className="slick-item-price-up sale">
											{formatCurrency(OriginalPrice)}
										</div>)
									}
								</div> */}
                {/* {product.StockLimited && product.StockQuantity > 0 && OriginalPrice && (
									<h1
										className="slick-item-price-up"
									>
										{formatCurrency(OriginalPrice)}
									</h1>
								)} */}
                {variantsArray?.length > 0 && (
                  <>
                    {variantsArray?.map((item: any, index) => {
                      let error_value = item.toLowerCase();
                      return (
                        <div key={index}>
                          <div className="error">
                            Please select {error_value}
                          </div>
                          <select
                            name=""
                            id="size"
                            className="variation"
                            defaultValue={`Please select ${error_value}`}
                            onChange={(e) => {
                              setVariantsError([]);
                              setProductQty(1);
                              variantsObject[item]?.map((item2) => {
                                if (e.target.value == item2.ID) {
                                  let arrray = variantsSelect;
                                  arrray[index] = item2.Name;
                                  let arrrayID = variantsSelectedID;
                                  arrrayID[index] = item2.ID;
                                  setVariantsSelect(arrray);
                                  setVariantsSelectedID(arrrayID);
                                }
                                console.log(
                                  "here is the selected variant image=======>",
                                  selectedVariantImage
                                );
                              });
                            }}
                          >
                            <option value="" selected disabled hidden>
                              Select {item}
                            </option>
                            {variantsObject[item]?.map((item2, index2) => {
                              return (
                                <option key={index2} value={item2.ID}>
                                  {item2?.Name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      );
                    })}
                    {variantsError.length > 0 &&
                      variantsError?.map((itemV: any, indexV) => {
                        itemV = itemV.toLowerCase();
                        return (
                          <div
                            key={indexV}
                            className="error"
                            style={{ display: "block" }}
                          >
                            Please select {itemV}
                          </div>
                        );
                      })}
                  </>
                )}
                {limitedStock && stock <= 5 && stock > 0 && (
                  <div
                    style={{
                      color: "#ef8822",
                      fontWeight: 500,
                      marginTop: "auto",
                      fontSize: "15px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    {" "}
                    Only {stock} left in stock
                  </div>
                )}
                {/* {product?.AddOns?.length < 1 && product?.StockLimited && product?.StockQuantity < 1 ?
									<div className="qty">
										<a className="greybutton soldout">Sold Out</a>
									</div>
									: */}
                <>
                  <div className="qty">
                    {!(btnTitle == "SOLD OUT" || btnTitle === 'NOT AVAILABLE') && (
                      <div className="plusminus">
                        <button
                          className="btn"
                          onClick={() => {
                            if (btnTitle == "Add to Bag") {
                              if (productQty > 1) setProductQty(productQty - 1);
                            }
                          }}
                        >
                          -
                        </button>
                        <div className="value">{productQty}</div>
                        <button
                          id="Button"
                          style={{ backgroundColor: "#fffff" }}
                          disabled={limitedStock && productQty == stock}
                          className="btn"
                          onClick={() => {
                            console.log(
                              "here is the stock,productQty and limited stock",
                              stock,
                              productQty,
                              limitedStock
                            );

                            if (btnTitle == "Add to Bag") {
                              setProductQty(productQty + 1);
                            }
                          }}
                        >
                          +
                        </button>
                      </div>
                    )}

                    {!(btnTitle == "SOLD OUT") ? (
                      <a
                      id="Add-To-Bag"
                        className="blackbutton"
                        onClick={() => {
                          if (btnTitle == "Add to Bag") {
                            addItemToCart();
                          }
                        }}
                      >
                        {is_loading ? (
                          <Loader
                            type="TailSpin"
                            color="white"
                            height={18}
                            width={18}
                          />
                        ) : (
                          btnTitle
                        )}
                      </a>
                    ) : (
                      <a style={{ cursor: "default" }} className="blackbutton">
                        {btnTitle}
                      </a>
                    )}
                  </div>
                  {dynamic_text !== "" && (
                    <div className="note">{dynamic_text}</div>
                  )}
                </>
                {/* } */}
              </div>
              {/* /option-panel */}
            </section>
            {/* /detail-selection */}

            {/* detail-description */}
            <section className="description">
              <div className="tabs">
                <div className="title">DESCRIPTION</div>
                {sizingChartImage !== "" && (
                  <div onClick={handleClick} className="sizing-btn">
                    Sizing Guide
                  </div>
                )}
                {show && (
                  <div className="sizing-guide active">
                    <div className="header">
                      <div className="title">SIZING GUIDE</div>
                      <div
                        className="close"
                        onClick={() => {
                          setShow(false);
                        }}
                      >
                        <img src="images/icon-x-white.svg" alt="" />
                      </div>
                    </div>
                    <img
                      src={sizingChartImage ? sizingChartImage : ""}
                      alt="Sizing Chart"
                    />
                  </div>
                )}
              </div>

              <div className="writeup">
                {dataLoading ? (
                  <MyListLoader />
                ) : product.BuyerDescription?.trim() == "" ? (
                  <div>-</div>
                ) : (
                  <div
                    style={{ whiteSpace: "pre-wrap" }}
                  >{`${product.BuyerDescription}`}</div>
                )}

                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 500,
                    color: "#000000",
                    marginTop: 30,
                  }}
                  className="title"
                >
                  RETURN
                </div>
                {returnLoading ? (
                  <MyListLoader />
                ) : (
                  returnPolicy && (
                    <div style={{ whiteSpace: "pre-wrap" }}>{returnPolicy}</div>
                  )
                )}

                {(fulfilmentDelivery || fulfilmentSelfCollection) && (
                  <>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: "#000000",
                        marginTop: 30,
                      }}
                      className="title"
                    >
                      FULFILMENT OPTIONS
                    </div>
                    {fulfilmentDelivery && (
                      <>
                        <div className={"title"} style={{ marginBottom: 0 }}>
                          {fulfilmentDelivery}
                        </div>
                        <div
                          style={{ whiteSpace: "pre-wrap", paddingLeft: 12 }}
                        >
                          {deliverySubText + "\n"}
                        </div>
                        <br />
                      </>
                    )}

                    {fulfilmentSelfCollection && (
                      <>
                        <div className={"title"} style={{ marginBottom: 0 }}>
                          - {fulfilmentSelfCollection}
                        </div>
                        <div
                          style={{ whiteSpace: "pre-wrap", paddingLeft: 12 }}
                        >
                          {SelfCollectionSubText + "\n"}
                        </div>
                      </>
                    )}
                  </>
                )}

                <br />
                <br />
              </div>
            </section>
            {/* /detail-description */}

            {/* you might also like */}
            <section className="related">
              <div className="title">You Might Also Like</div>

              {/* /minicarousel*/}
              {productsLoading ? (
                <MyLoader />
              ) : (
                <div className="minicarousel four">
                  {isTabletOrMobile || isTabletOrMobileDevice
                    ? renderMiniSlider(productList, 2)
                    : renderMiniSlider(productList, 4)}
                </div>
              )}
              {/* /minicarousel*/}
            </section>
            {/* /you might also like */}
          </div>
          {/* /detail */}
        </div>
        {/* /content*/}
      </div>
      {/* /container */}

      {/* footer */}
      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />
      {/* /footer */}
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, allCategories } = state.UserReducer;
  return { cart_count, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  UpdateCartID,
};
export default connect(mapStateToProps, actions)(ProductDesc);
